export enum ContentHeaders {
  ContentType = 'content-type',
  ContentDisposition = 'content-disposition',
}
